import { Time } from "./Time"
const install = function (Vue) {

  Vue.directive('relativeTime', {
    bind(el, binding) {
      // Time.getFormatTime() 方法，自行补充
      el.innerHTML = Time.getFormatTime(binding.value)
      el.__timeout__ = setInterval(() => {
        el.innerHTML = Time.getFormatTime(binding.value)
      }, 6000)
    },
    unbind(el) {
      clearInterval(el.innerHTML)
      delete el.__timeout__
    }
  })

}

// if (window.Vue) {

//   Vue.use(install); // eslint-disable-line
// }

export default install